<div class="facilities-table">
  <p-dataView #dv [value]="facilities()">
    <p-header>
      <h2 class="data-view-header">{{ header() }}</h2>
    </p-header>
    <ng-template let-facilities #list>
      @for (fac of facilities; track fac) {
        <div class="facilities-list-item">
          <div>
            <div class="facilities-table-row">
              <div class="icon">
                @if (canDelete()) {
                  <i
                    class="fa fa-fw fa-minus-circle loc-delete-icon"
                    (click)="deleteContactListFromFacility(fac.id)"
                  ></i>
                }
              </div>
              <div class="facilities-data">
                <div class="data-row">
                  <div class="item">
                    <div class="label">
                      {{ 'LOCATION.LABEL.STATE' | translate }}:
                    </div>
                    <div>
                      {{ fac.state }}
                    </div>
                  </div>
                  <div class="item">
                    <div class="label">
                      {{ 'LOCATION.LABEL.COUNTY' | translate }}:
                    </div>
                    <div>
                      {{ fac.county }}
                    </div>
                  </div>
                  <div class="item">
                    <div class="label">
                      {{ 'LOCATION.LABEL.TOWNSHIP' | translate }}:
                    </div>
                    <div>
                      {{ fac.township }}
                    </div>
                  </div>
                </div>
                <div class="data-row">
                  <div class="item">
                    <div class="label">
                      {{ 'ADMIN.LABEL.NAME' | translate }}:
                    </div>
                    <div>
                      {{ fac.facilityName }}
                    </div>
                  </div>
                  <div class="item">
                    <div class="label">
                      {{ 'LOCATION.LABEL.ID' | translate }}:
                    </div>
                    <div>
                      {{ fac.facilityUid }}
                    </div>
                  </div>
                  <div class="item">
                    <div class="label">{{ 'CRM.LABEL.TYPE' | translate }}:</div>
                    <div>
                      {{ fac.facilityType }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="save">
                <button
                  pButton
                  type="button"
                  (click)="openFacility(fac)"
                  label="{{ 'COMMON.LABEL.BUTTONS.OPEN' | translate }}"
                ></button>
              </div>
            </div>
          </div>
        </div>
      }
    </ng-template>
  </p-dataView>
</div>
